// extracted by mini-css-extract-plugin
module.exports = {"betSlipContainer":"_97012ef"};